export type Config = {
  [key: string]: any;
};

const REMOTE_CONFIG_URL = process.env.NEXT_PUBLIC_REMOTE_APP_CONFIG;

const fetchConfig = async (url?: string): Promise<Config | null> => {
  if (!url) {
    console.warn('No remote config URL provided.');
    return null;
  }
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch config from ${url}:`, error);
    return null;
  }
};

const getConfig = async (): Promise<Config | null> => {
  let config: Config = {};

  try {
    const remoteConfig = await fetchConfig(REMOTE_CONFIG_URL);
    const localConfig = require('./local-config.json') as Config;

    config = { ...localConfig, ...remoteConfig };
  } catch (error) {
    console.error('Failed to load local config:', error);
    return null;
  }

  return config;
};

export default getConfig;
